const categories = [
  { name: '热血漫画', icon: 'ri-fire-line', color: 'text-primary-600', bg: 'bg-primary-100', count: '3,280部' },
  { name: '恋爱漫画', icon: 'ri-heart-line', color: 'text-secondary-600', bg: 'bg-secondary-100', count: '2,156部' },
  { name: '搞笑漫画', icon: 'ri-emotion-laugh-line', color: 'text-accent-600', bg: 'bg-accent-100', count: '1,894部' },
  { name: '悬疑漫画', icon: 'ri-search-eye-line', color: 'text-primary-600', bg: 'bg-primary-100', count: '1,032部' },
  { name: '奇幻漫画', icon: 'ri-magic-line', color: 'text-accent-600', bg: 'bg-accent-100', count: '2,410部' },
  { name: '仙侠漫画', icon: 'ri-rocket-line', color: 'text-secondary-600', bg: 'bg-secondary-100', count: '1,768部' },
  { name: '竞技漫画', icon: 'ri-trophy-line', color: 'text-primary-600', bg: 'bg-primary-100', count: '856部' },
  { name: '都市漫画', icon: 'ri-building-line', color: 'text-accent-600', bg: 'bg-accent-100', count: '2,043部' },
  { name: '科幻漫画', icon: 'ri-planet-line', color: 'text-secondary-600', bg: 'bg-secondary-100', count: '1,320部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">分类索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">全品类漫画分类，快速找到你喜欢的题材</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-4 md:gap-5 max-w-[960px] mx-auto">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href="#cards"
              className="flex items-center gap-4 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer no-underline group"
            >
              <span className={`w-11 h-11 rounded-xl ${cat.bg} ${cat.color} flex items-center justify-center flex-shrink-0`}>
                <i className={`${cat.icon} text-lg`}></i>
              </span>
              <div>
                <div className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{cat.name}</div>
                <div className="text-xs text-foreground-500">{cat.count}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}